import * as React from "react";

import { PresentationSortingOption } from "../../model";

import { useProductListState_asController } from "./product-list-state-provider";

interface ProductListController_ForSorting_ConsumerInterface {
  chooseSortingOption: (option: PresentationSortingOption) => void;
}

const defaultValue =
  {} as unknown as ProductListController_ForSorting_ConsumerInterface;

const ProductListController_ForSorting_Context =
  React.createContext(defaultValue);

export const ProductListController_ForSorting_Provider: React.FunctionComponent =
  (props) => {
    const { setSelectedSortingOption } = useProductListState_asController();
    const chooseSortingOption = React.useCallback(
      (option: PresentationSortingOption) => {
        setSelectedSortingOption(option);
      },
      [setSelectedSortingOption]
    );

    const value: ProductListController_ForSorting_ConsumerInterface =
      React.useMemo(
        () => ({
          chooseSortingOption,
        }),
        [chooseSortingOption]
      );
    return (
      <ProductListController_ForSorting_Context.Provider value={value}>
        {props.children || []}
      </ProductListController_ForSorting_Context.Provider>
    );
  };

export const useProductListController_forSorting = () => {
  const context = React.useContext(ProductListController_ForSorting_Context);
  if (context === defaultValue) {
    throw new Error(
      "useProductListController_forSorting must be used within a ProductListController_ForSorting_Provider"
    );
  }
  return context;
};
